module.exports = __webpack_public_path__ + "components/panel/ski-bro/static/swiss@2-6ac2a2e78386b2ec93e041e65d62c4ef.jpg";